// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wK4b","title":"styles_title__2kyP6"};